import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * 系统中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      }
    ]
  },
  {
    path: '/br',
    name: 'br',
    component: Main,
    meta: {
      title: '业务报表',
      icon: 'md-people',
      access: ['admin', 'dev1', 'marketsales', 'operator', 'operator1']
    },
    children: [
      {
        path: 'personaldevelopreport',
        name: 'personaldevelopreport',
        meta: {
          access: ['admin'],
          icon: 'md-car',
          title: '个人业务统计报表',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/br/personal-br-report.vue')
      },
      {
        path: 'groupbrreport',
        name: 'groupbrreport',
        meta: {
          access: ['admin'],
          icon: 'md-car',
          title: '分组业务统计报表',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/br/group-br-report.vue')
      }
    ]
  },
  {
    path: '/crm',
    name: 'crm',
    component: Main,
    meta: {
      title: '客户关系管理',
      icon: 'md-people',
      access: ['admin', 'dev1', 'marketsales', 'operator', 'operator1']
    },
    children: [
      // {
      //   path: 'potentialgroups',
      //   name: 'potentialgroups',
      //   meta: {
      //     access: ['admin', 'marketsales', 'operator'],
      //     icon: 'md-car',
      //     title: '潜在分组查询',
      //     beforeCloseName: 'before_close_normal'
      //   },
      //   component: () => import('@/view/crm/potential-groups')
      // },
      {
        path: 'combovehicleinfos',
        name: 'combovehicleinfos',
        meta: {
          access: ['admin', 'marketsales', 'operator'],
          icon: 'md-car',
          title: '潜在合拼车辆查询',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/combo-vehicle-infos')
      },
      // {
      //   path: 'potentialvehicleinfos',
      //   name: 'potentialvehicleinfos',
      //   meta: {
      //     icon: 'md-car',
      //     title: '潜在客户车辆管理'
      //   },
      //   component: () => import('@/view/crm/potential-vehicleinfos')
      // },
      {
        path: 'clientinfos',
        name: 'clientinfos',
        meta: {
          access: ['admin', 'operator', 'customerservice'],
          icon: 'md-people',
          title: '客户信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/clientinfos')
      },
      {
        path: 'myclientinfos',
        name: 'myclientinfos',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'md-people',
          title: '我的客户信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/my-client-infos')
      },
      {
        path: 'vehicleownerinfos',
        name: 'vehicleownerinfos',
        meta: {
          access: ['admin', 'marketsales', 'operator'],
          icon: 'md-person',
          title: '车辆所有人信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/vehicle-owner-infos')
      },
      {
        path: 'vehicledriverinfos',
        name: 'vehicledriverinfos',
        meta: {
          access: ['admin', 'marketsales', 'operator'],
          icon: 'md-speedometer',
          title: '驾驶员信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/vehicle-driver-infos')
      },
      {
        path: 'vehicleinfogroups',
        name: 'vehicleinfogroups',
        meta: {
          access: ['admin', 'operator'],
          icon: 'md-car',
          title: '车辆分组管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/vehicle-info-groups')
      },
      {
        path: 'myvehicleinfogroups',
        name: 'myvehicleinfogroups',
        meta: {
          access: ['admin', 'operator', 'marketsales'],
          icon: 'md-car',
          title: '我的车辆分组',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/my-vehicle-info-groups')
      },
      {
        path: 'vehicleinfos',
        name: 'vehicleinfos',
        meta: {
          access: ['admin', 'dev1', 'operator', 'dev1'],
          icon: 'md-car',
          title: '车辆信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/vehicle-infos')
      },
      {
        path: 'usergroupvehicleinfos',
        name: 'usergroupvehicleinfos',
        meta: {
          access: ['admin', 'dev1', 'operator', 'operator1'],
          icon: 'md-car',
          title: '团队车辆信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/usergroup-vehicle-infos')
      },
      {
        path: 'myvehicleinfos',
        name: 'myvehicleinfos',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'md-car',
          title: '我的车辆信息管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/my-vehicle-infos')
      },
      {
        path: 'clients',
        name: 'clients',
        meta: {
          access: ['admin'],
          icon: 'md-car',
          title: '客户账号管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/clients')
      },
      {
        path: 'saleschannel',
        name: 'saleschannel',
        meta: {
          access: ['admin', 'marketsales', 'operator', 'operator1'],
          icon: 'md-car',
          title: '销售渠道管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/saleschannel-info')
      },
      {
        path: 'insurancechannel',
        name: 'insurancechannel',
        meta: {
          access: ['admin', 'marketsales', 'operator', 'operator1'],
          icon: 'md-car',
          title: '保险渠道管理',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/insurancechannel-info')
      },
      {
        path: 'freeinstallationaudit',
        name: 'freeinstallationaudit',
        meta: {
          access: ['admin', 'operator', 'accountant'],
          icon: 'ios-folder-open',
          title: '重货保险免费安装主动安全设备登记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/free-installation-audit')
      },
      {
        path: 'usergroupfreeinstallationaudit',
        name: 'usergroupfreeinstallationaudit',
        meta: {
          access: ['admin', 'marketsales', 'operator', 'operator1', 'accountant'],
          icon: 'ios-folder-open',
          title: '团队重货保险免费安装主动安全设备登记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/usergroup-free-installation-audit')
      }
    ]
  },
  {
    path: '/businessnote',
    name: 'businessnote',
    component: Main,
    meta: {
      title: '业务笔记',
      icon: 'md-book',
      access: ['admin', 'marketsales', 'operator']
    },
    children: [
      {
        path: 'mybusinessnotes',
        name: 'mybusinessnotes',
        meta: {
          access: ['admin', 'operator', 'marketsales'],
          icon: 'md-book',
          title: '我的业务笔记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/my-business-notes')
      },
      {
        path: 'mycombovehicleinfobusinessnotes',
        name: 'mycombovehicleinfobusinessnotes',
        meta: {
          access: ['admin', 'operator', 'marketsales'],
          icon: 'md-book',
          title: '我的潜在合拼车辆笔记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/my-combo-vehicle-info-business-notes')
      },
      {
        path: 'usergroupvehicleinfobusinessnotes',
        name: 'usergroupvehicleinfobusinessnotes',
        meta: {
          access: ['admin'],
          icon: 'md-book',
          title: '团队潜在合拼车辆笔记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/usergroup-vehicle-info-business-notes')
      },
      {
        path: 'allvehicleinfobusinessnotes',
        name: 'allvehicleinfobusinessnotes',
        meta: {
          access: ['admin'],
          icon: 'md-book',
          title: '所有潜在合拼车辆笔记',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/crm/all-vehicle-info-business-notes')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant', 'dev1', 'installer'],
      title: '新增订单管理',
      icon: 'md-clipboard'
    },
    children: [
      {
        path: 'installorders',
        name: 'installorders',
        meta: {
          access: ['admin', 'accountant', 'dev1'],
          icon: 'md-clipboard',
          title: '新增订单管理'
        },
        component: () => import('@/view/om/installorder/install-orders')
      },
      {
        path: 'usergroupinstallorders',
        name: 'usergroupinstallorders',
        meta: {
          access: ['admin', 'operator1'],
          icon: 'md-clipboard',
          title: '新增订单-文员'
        },
        component: () => import('@/view/om/installorder/usergroup-install-orders')
      },
      {
        path: 'mybusinessinstallorders',
        name: 'mybusinessinstallorders',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'md-clipboard',
          title: '新增订单-业务'
        },
        component: () => import('@/view/om/installorder/my-business-install-orders')
      },
      {
        path: 'auditinstallorders',
        name: 'auditinstallorders',
        meta: {
          access: ['admin', 'operator', 'accountant'],
          icon: 'md-clipboard',
          title: '新增订单-审核'
        },
        component: () => import('@/view/om/installorder/audit-install-orders')
      },
      {
        path: 'distributioninstallorders',
        name: 'distributioninstallorders',
        meta: {
          access: ['admin', 'distribution'],
          icon: 'md-clipboard',
          title: '新增订单-仓库'
        },
        component: () => import('@/view/om/installorder/distribution-install-orders')
      },
      {
        path: 'callbackinstallorders',
        name: 'callbackinstallorders',
        meta: {
          access: ['admin', 'marketsales', 'customerservice'],
          icon: 'md-clipboard',
          title: '新增订单-回访'
        },
        component: () => import('@/view/om/installorder/callback-install-orders')
      },
      {
        path: 'receptinstallorders',
        name: 'receptinstallorders',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'accountant'],
          icon: 'md-clipboard',
          title: '新增订单-收款'
        },
        component: () => import('@/view/om/installorder/recept-install-orders')
      },
      {
        path: 'installerinstallorders',
        name: 'installerinstallorders',
        meta: {
          access: ['admin', 'installer'],
          icon: 'md-clipboard',
          title: '新增订单-安装员'
        },
        component: () => import('@/view/om/installorder/installer-install-orders')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant', 'dev1'],
      title: '续费订单管理',
      icon: 'ios-clipboard'
    },
    children: [
      {
        path: 'renewalorders',
        name: 'renewalorders',
        meta: {
          access: ['admin', 'accountant', 'dev1'],
          icon: 'ios-clipboard',
          title: '续费订单管理'
        },
        component: () => import('@/view/om/renewalorder/renewal-orders')
      },
      {
        path: 'usergrouprenewalorders',
        name: 'usergrouprenewalorders',
        meta: {
          access: ['admin', 'operator1'],
          icon: 'ios-clipboard',
          title: '续费订单-文员'
        },
        component: () => import('@/view/om/renewalorder/usergroup-renewal-orders')
      },
      {
        path: 'mybusinessrenewalorders',
        name: 'mybusinessrenewalorders',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'ios-clipboard',
          title: '续费订单-业务'
        },
        component: () => import('@/view/om/renewalorder/my-business-renewal-orders')
      },
      {
        path: 'auditrenewalorders',
        name: 'auditrenewalorders',
        meta: {
          access: ['admin', 'operator', 'accountant'],
          icon: 'ios-clipboard',
          title: '续费订单-审核'
        },
        component: () => import('@/view/om/renewalorder/audit-renewal-orders')
      },
      {
        path: 'callbackrenewalorders',
        name: 'callbackrenewalorders',
        meta: {
          access: ['admin', 'marketsales', 'customerservice'],
          icon: 'ios-clipboard',
          title: '续费订单-回访'
        },
        component: () => import('@/view/om/renewalorder/callback-renewal-orders')
      },
      {
        path: 'receptrenewalorders',
        name: 'receptrenewalorders',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'accountant'],
          icon: 'ios-clipboard',
          title: '续费订单-收款'
        },
        component: () => import('@/view/om/renewalorder/recept-renewal-orders')
      },
      {
        path: 'jt808servcombineorders',
        name: 'jt808servcombineorders',
        meta: {
          access: ['admin', 'operator', 'operator1', 'accountant'],
          icon: 'md-hammer',
          title: '合拼部标服务订单'
        },
        component: () => import('@/view/om/jt808-serv-combine-orders')
      },
      {
        path: 'usergroupjt808servcombineorders',
        name: 'usergroupjt808servcombineorders',
        meta: {
          access: ['admin', 'operator', 'operator1', 'customerservice', 'accountant'],
          icon: 'md-hammer',
          title: '团队合拼部标服务订单'
        },
        component: () => import('@/view/om/usergroup-jt808-serv-combine-orders')
      },
      {
        path: 'mybusinessjt808servcombineorders',
        name: 'mybusinessjt808servcombineorders',
        meta: {
          access: ['admin', 'operator', 'customerservice', 'accountant'],
          icon: 'md-hammer',
          title: '我的合拼部标服务订单'
        },
        component: () => import('@/view/om/my-business-jt808-serv-combine-orders')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant'],
      title: '三方监控订单管理',
      icon: 'ios-clipboard-outline'
    },
    children: [
      {
        path: 'monitoringserviceorder',
        name: 'monitoringserviceorder',
        meta: {
          access: ['admin', 'accountant'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单管理'
        },
        component: () => import('@/view/om/monitoringserviceorder/monitoring-service-order')
      },
      {
        path: 'usergroupmonitoringserviceorder',
        name: 'usergroupmonitoringserviceorder',
        meta: {
          access: ['admin', 'operator1'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-文员'
        },
        component: () => import('@/view/om/monitoringserviceorder/usergroup-monitoring-service-order')
      },
      {
        path: 'mybusinessmonitoringserviceorder',
        name: 'mybusinessmonitoringserviceorder',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-业务'
        },
        component: () => import('@/view/om/monitoringserviceorder/my-business-monitoring-service-order')
      },
      {
        path: 'auditmonitoringserviceorder',
        name: 'auditmonitoringserviceorder',
        meta: {
          access: ['admin', 'operator', 'accountant'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-审核'
        },
        component: () => import('@/view/om/monitoringserviceorder/audit-monitoring-service-order')
      },
      {
        path: 'connectmonitoringserviceorder',
        name: 'connectmonitoringserviceorder',
        meta: {
          access: ['admin', 'customerservice'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-对接'
        },
        component: () => import('@/view/om/monitoringserviceorder/connect-monitoring-service-order')
      },
      {
        path: 'callbackmonitoringserviceorder',
        name: 'callbackmonitoringserviceorder',
        meta: {
          access: ['admin', 'marketsales', 'customerservice'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-回访'
        },
        component: () => import('@/view/om/monitoringserviceorder/callback-monitoring-service-order')
      },
      {
        path: 'receptmonitoringserviceorder',
        name: 'receptmonitoringserviceorder',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'accountant'],
          icon: 'ios-clipboard-outline',
          title: '三方监控订单-收款'
        },
        component: () => import('@/view/om/monitoringserviceorder/recept-monitoring-service-order')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant'],
      title: '三方监控续费订单管理',
      icon: 'ios-clipboard'
    },
    children: [
      {
        path: 'monitoringservice',
        name: 'monitoringservice',
        meta: {
          access: ['admin', 'accountant'],
          icon: 'md-hammer',
          title: '三方监控续费订单管理'
        },
        component: () => import('@/view/om/monitoringservice/monitoring-service')
      },
      {
        path: 'usergroupmonitoringservice',
        name: 'usergroupmonitoringservice',
        meta: {
          access: ['admin', 'operator1'],
          icon: 'ios-clipboard',
          title: '三方监控续费订单-文员'
        },
        component: () => import('@/view/om/monitoringservice/usergroup-monitoring-service')
      },
      {
        path: 'mybusinessmonitoringservice',
        name: 'mybusinessmonitoringservice',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'ios-clipboard',
          title: '三方监控续费订单-业务'
        },
        component: () => import('@/view/om/monitoringservice/my-business-monitoring-service')
      },
      {
        path: 'auditmonitoringservice',
        name: 'auditmonitoringservice',
        meta: {
          access: ['admin', 'operator', 'accountant'],
          icon: 'ios-clipboard',
          title: '三方监控续费订单-审核'
        },
        component: () => import('@/view/om/monitoringservice/audit-monitoring-service')
      },
      {
        path: 'callbackmonitoringservice',
        name: 'callbackmonitoringservice',
        meta: {
          access: ['admin', 'marketsales', 'customerservice'],
          icon: 'ios-clipboard',
          title: '三方监控续费订单-回访'
        },
        component: () => import('@/view/om/monitoringservice/callback-monitoring-service')
      },
      {
        path: 'receptmonitoringservice',
        name: 'receptmonitoringservice',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'accountant'],
          icon: 'ios-clipboard',
          title: '三方监控续费订单-收款'
        },
        component: () => import('@/view/om/monitoringservice/recept-monitoring-service')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant', 'dev1'],
      title: '维修订单管理',
      icon: 'md-clipboard'
    },
    children: [
      {
        path: 'technicalassistance',
        name: 'technicalassistance',
        meta: {
          access: ['admin', 'accountant', 'dev1'],
          icon: 'md-clipboard',
          title: '技术协助'
        },
        component: () => import('@/view/om/technicalassistance/technical-assistance')
      },
      {
        path: 'usergrouptechnicalassistance',
        name: 'usergrouptechnicalassistance',
        meta: {
          access: ['admin', 'marketsales', 'operator1', 'dev1', 'customerservice'],
          icon: 'md-clipboard',
          title: '技术协助-团队'
        },
        component: () => import('@/view/om/technicalassistance/usergroup-technical-assistance')
      },
      {
        path: 'maintainorders',
        name: 'maintainorders',
        meta: {
          access: ['admin', 'operator', 'accountant', 'dev1'],
          icon: 'md-clipboard',
          title: '维修订单管理'
        },
        component: () => import('@/view/om/maintainorder/maintain-orders')
      },
      {
        path: 'usergroupmaintainorders',
        name: 'usergroupmaintainorders',
        meta: {
          access: ['admin', 'operator1', 'operator'],
          icon: 'md-clipboard',
          title: '维修订单-文员'
        },
        component: () => import('@/view/om/maintainorder/usergroup-maintain-orders')
      },
      {
        path: 'mybusinessmaintainorders',
        name: 'mybusinessmaintainorders',
        meta: {
          access: ['admin', 'marketsales'],
          icon: 'md-clipboard',
          title: '维修订单-业务'
        },
        component: () => import('@/view/om/maintainorder/my-business-maintain-orders')
      },
      // {
      //   path: 'auditmaintainorders',
      //   name: 'auditmaintainorders',
      //   meta: {
      //     access: ['admin', 'operator', 'accountant'],
      //     icon: 'md-clipboard',
      //     title: '维修订单-审核'
      //   },
      //   component: () => import('@/view/om/maintainorder/audit-maintain-orders')
      // },
      // {
      //   path: 'distributionmaintainorders',
      //   name: 'distributionmaintainorders',
      //   meta: {
      //     access: ['admin','distribution'],
      //     icon: 'md-clipboard',
      //     title: '维修订单-仓库'
      //   },
      //   component: () => import('@/view/om/maintainorder/distribution-maintain-orders')
      // },
      {
        path: 'callbackmaintainorders',
        name: 'callbackmaintainorders',
        meta: {
          access: ['admin', 'marketsales', 'customerservice'],
          icon: 'md-clipboard',
          title: '维修订单-回访'
        },
        component: () => import('@/view/om/maintainorder/callback-maintain-orders')
      },
      // {
      //   path: 'receptmaintainorders',
      //   name: 'receptmaintainorders',
      //   meta: {
      //     access: ['admin', 'operator', 'marketsales', 'accountant'],
      //     icon: 'md-clipboard',
      //     title: '维修订单-收款'
      //   },
      //   component: () => import('@/view/om/maintainorder/recept-maintain-orders')
      // },
      {
        path: 'maintainordersstatistics',
        name: 'maintainordersstatistics',
        meta: {
          access: ['admin', 'dev1', 'operator', 'operator1'],
          icon: 'md-hammer',
          title: '维修订单团队统计'
        },
        component: () => import('@/view/om/maintain-orders-statistics')
      }
    ]
  },
  {
    path: '/om',
    name: 'om',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'operator1', 'customerservice', 'accountant', 'dev1'],
      title: '合拼部标服务管理',
      icon: 'md-clipboard'
    },
    children: [
      {
        path: 'jt808servcombineorders',
        name: 'jt808servcombineorders',
        meta: {
          access: ['admin', 'accountant', 'operator1'],
          icon: 'md-hammer',
          title: '合拼部标服务订单'
        },
        component: () => import('@/view/om/jt808-serv-combine-orders')
      },
      {
        path: 'usergroupjt808servcombineorders',
        name: 'usergroupjt808servcombineorders',
        meta: {
          access: ['admin', 'operator', 'customerservice', 'accountant'],
          icon: 'md-hammer',
          title: '团队合拼部标服务订单'
        },
        component: () => import('@/view/om/usergroup-jt808-serv-combine-orders')
      },
      {
        path: 'mybusinessjt808servcombineorders',
        name: 'mybusinessjt808servcombineorders',
        meta: {
          access: ['admin', 'operator', 'customerservice', 'accountant'],
          icon: 'md-hammer',
          title: '我的合拼部标服务订单'
        },
        component: () => import('@/view/om/my-business-jt808-serv-combine-orders')
      }
    ]
  },
  // {
  //   path: '/om',
  //   name: 'om',
  //   component: Main,
  //   meta: {
  //     access: ['admin', 'dev1', 'operator', 'marketsales', 'customerservice', 'accountant'],
  //     title: '订单管理',
  //     icon: 'md-clipboard'
  //   },
  //   children: [
  //     {
  //       path: 'installorders',
  //       name: 'installorders',
  //       meta: {
  //         access: ['admin', 'dev1', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '安装订单管理'
  //       },
  //       component: () => import('@/view/om/install-orders')
  //     },
  //     {
  //       path: 'usergroupinstallorders',
  //       name: 'usergroupinstallorders',
  //       meta: {
  //         access: ['admin', 'dev1', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '团队安装订单'
  //       },
  //       component: () => import('@/view/om/usergroup-install-orders')
  //     },
  //     {
  //       path: 'mybusinessinstallorders',
  //       name: 'mybusinessinstallorders',
  //       meta: {
  //         access: ['admin', 'marketsales'],
  //         icon: 'md-hammer',
  //         title: '我的安装业务订单'
  //       },
  //       component: () => import('@/view/om/my-business-install-orders')
  //     },
  //     {
  //       path: 'renewalorders',
  //       name: 'renewalorders',
  //       meta: {
  //         access: ['admin', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '续费订单管理'
  //       },
  //       component: () => import('@/view/om/renewal-orders')
  //     },
  //     {
  //       path: 'usergrouprenewalorders',
  //       name: 'usergrouprenewalorders',
  //       meta: {
  //         access: ['admin', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '团队续费订单'
  //       },
  //       component: () => import('@/view/om/usergroup-renewal-orders')
  //     },
  //     {
  //       path: 'mybusinessrenewalorders',
  //       name: 'mybusinessrenewalorders',
  //       meta: {
  //         access: ['admin', 'marketsales'],
  //         icon: 'md-hammer',
  //         title: '我的续费订单管理'
  //       },
  //       component: () => import('@/view/om/my-business-renewal-orders')
  //     },
  //     {
  //       path: 'jt808servcombineorders',
  //       name: 'jt808servcombineorders',
  //       meta: {
  //         access: ['admin', 'accountant', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '合拼部标服务订单'
  //       },
  //       component: () => import('@/view/om/jt808-serv-combine-orders')
  //     },
  //     {
  //       path: 'usergroupjt808servcombineorders',
  //       name: 'usergroupjt808servcombineorders',
  //       meta: {
  //         access: ['admin', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '团队合拼部标服务订单'
  //       },
  //       component: () => import('@/view/om/usergroup-jt808-serv-combine-orders')
  //     },
  //     {
  //       path: 'mybusinessjt808servcombineorders',
  //       name: 'mybusinessjt808servcombineorders',
  //       meta: {
  //         access: ['admin', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '我的合拼部标服务订单'
  //       },
  //       component: () => import('@/view/om/my-business-jt808-serv-combine-orders')
  //     },
  //     {
  //       path: 'maintainorders',
  //       name: 'maintainorders',
  //       meta: {
  //         access: ['admin', 'dev1'],
  //         icon: 'md-hammer',
  //         title: '维修订单管理'
  //       },
  //       component: () => import('@/view/om/maintain-orders')
  //     },
  //     {
  //       path: 'usergroupmaintainorders',
  //       name: 'usergroupmaintainorders',
  //       meta: {
  //         access: ['admin', 'dev1', 'operator', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '团队维修订单管理'
  //       },
  //       component: () => import('@/view/om/usergroup-maintain-orders')
  //     },
  //     {
  //       path: 'maintainordersstatistics',
  //       name: 'maintainordersstatistics',
  //       meta: {
  //         access: ['admin', 'dev1', 'operator', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '团队维修订单统计'
  //       },
  //       component: () => import('@/view/om/maintain-orders-statistics')
  //     },
  //     {
  //       path: 'maintaindevicerecord',
  //       name: 'maintaindevicerecord',
  //       meta: {
  //         access: ['admin', 'dev1', 'operator', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '维修记录统计'
  //       },
  //       component: () => import('@/view/om/maintain-device-record')
  //     },
  //     {
  //       path: 'maintaindevicerecordgroup',
  //       name: 'maintaindevicerecordgroup',
  //       meta: {
  //         access: ['admin', 'dev1', 'operator', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '团队维修记录统计'
  //       },
  //       component: () => import('@/view/om/maintain-device-record-group')
  //     },
  //     {
  //       path: 'monitoringserviceorder',
  //       name: 'monitoringserviceorder',
  //       meta: {
  //         access: ['admin', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '三方监控'
  //       },
  //       component: () => import('@/view/om/monitoring-service-order')
  //     },
  //     {
  //       path: 'monitoringservice',
  //       name: 'monitoringservice',
  //       meta: {
  //         access: ['admin', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '三方监控续费'
  //       },
  //       component: () => import('@/view/om/monitoring-service')
  //     },
  //     {
  //       path: 'usergroupmonitoringserviceorder',
  //       name: 'usergroupmonitoringserviceorder',
  //       meta: {
  //         access: ['admin', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '团队三方监控'
  //       },
  //       component: () => import('@/view/om/usergroup-monitoring-service-order')
  //     },
  //     {
  //       path: 'usergroupmonitoringservice',
  //       name: 'usergroupmonitoringservice',
  //       meta: {
  //         access: ['admin', 'operator', 'customerservice', 'accountant'],
  //         icon: 'md-hammer',
  //         title: '团队三方监控续费'
  //       },
  //       component: () => import('@/view/om/usergroup-monitoring-service')
  //     },
  //     {
  //       path: 'mybusinessmonitoringserviceorder',
  //       name: 'mybusinessmonitoringserviceorder',
  //       meta: {
  //         access: ['admin', 'marketsales'],
  //         icon: 'md-hammer',
  //         title: '我的三方监控'
  //       },
  //       component: () => import('@/view/om/my-business-monitoring-service-order')
  //     },
  //     {
  //       path: 'mybusinessmonitoringservice',
  //       name: 'mybusinessmonitoringservice',
  //       meta: {
  //         access: ['admin', 'marketsales'],
  //         icon: 'md-hammer',
  //         title: '我的三方监控续费'
  //       },
  //       component: () => import('@/view/om/my-business-monitoring-service')
  //     },
  //     {
  //       path: 'payorder',
  //       name: 'payorder',
  //       meta: {
  //         access: ['admin', 'operator', 'operator1'],
  //         icon: 'md-hammer',
  //         title: '支付订单'
  //       },
  //       component: () => import('@/view/om/pay-order')
  //     }
  //   ]
  // },
  {
    path: '/ddm',
    name: 'ddm',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'operator1', 'dev1', 'installer'],
      title: '动态数据管理',
      icon: 'md-barcode'
    },
    children: [
      {
        path: 'shortmessagesdebug',
        name: 'shortmessagesdebug',
        meta: {
          access: ['admin', 'operator', 'operator1', 'dev1'],
          icon: 'md-paper',
          title: '短信管理'
        },
        component: () => import('@/view/ddm/short-messages-debug')
      },
      {
        path: 'jt808devices',
        name: 'jt808devices',
        meta: {
          access: ['admin', 'operator', 'operator1', 'installer', 'dev1'],
          icon: 'md-cloud',
          title: 'JT808数据'
        },
        component: () => import('@/view/ddm/jt808-devices')
      },
      {
        path: 'jt808sendcmd',
        name: 'jt808sendcmd',
        meta: {
          access: ['admin', 'dev1'],
          icon: 'md-cloud',
          title: '指令模块'
        },
        component: () => import('@/view/ddm/jt808-sendcmd')
      },
      // {
      //   path: 'jcicpdebug',
      //   name: 'jcicpdebug',
      //   meta: {
      //     access: ['admin'],
      //     icon: 'md-cloud',
      //     title: 'jcicp调试'
      //   },
      //   component: () => import('@/view/ddm/jcicp-debug')
      // },
      // {
      //   path: 'realtimemonitor',
      //   name: 'realtimemonitor',
      //   meta: {
      //     access: ['admin'],
      //     icon: 'md-cloud',
      //     title: '实时监控'
      //   },
      //   component: () => import('@/view/ddm/realtime-monitor')
      // },
      // {
      //   path: 'realtimemonitor2',
      //   name: 'realtimemonitor2',
      //   meta: {
      //     access: ['admin', 'operator', 'dev1'],
      //     icon: 'md-cloud',
      //     title: '实时监控'
      //   },
      //   component: () => import('@/view/ddm/realtime-monitor2')
      // },
      // {
      //   path: 'realtimemonitoramap',
      //   name: 'realtimemonitoramap',
      //   meta: {
      //     access: ['admin', 'operator', 'dev1'],
      //     icon: 'md-cloud',
      //     title: '实时监控高德地图'
      //   },
      //   component: () => import('@/view/ddm/realtime-monitor-amap')
      // },
      // {
      //   path: 'realtimemonitorbmap',
      //   name: 'realtimemonitorbmap',
      //   meta: {
      //     access: ['admin', 'operator', 'dev1'],
      //     icon: 'md-cloud',
      //     title: '实时监控百度地图'
      //   },
      //   component: () => import('@/view/ddm/realtime-monitor-bmap')
      // },
      {
        path: 'realtimemonitorbarcgis',
        name: 'realtimemonitorbarcgis',
        meta: {
          access: ['admin', 'operator', 'dev1'],
          icon: 'md-cloud',
          title: '实时监控Arcgis'
        },
        component: () => import('@/view/ddm/realtime-monitor-arcgis')
      },
      {
        path: 'avfileuploadrequesttasks',
        name: 'avfileuploadrequesttasks',
        meta: {
          access: ['admin', 'operator', 'operator1', 'installer', 'dev1'],
          icon: 'md-cloud',
          title: '音视频文件上传任务'
        },
        component: () => import('@/view/ddm/av-file-upload-request-task')
      }
      // {
      //   path: 'rtplayer',
      //   name: 'rtplayer',
      //   meta: {
      //     access: ['admin', 'operator', 'dev1'],
      //     icon: 'md-cloud',
      //     title: '实时视频'
      //   },
      //   component: () => import('@/view/ddm/rtplayer')
      // }
      // {
      //   path: 'videosurveillance',
      //   name: 'videosurveillance',
      //   meta: {
      //     access: ['admin', 'operator', 'dev1', 'marketsales', 'customerservice'],
      //     icon: 'md-cloud',
      //     title: '视频监控'
      //   },
      //   component: () => import('@/view/ddm/video-surveillance')
      // }
    ]
  },
  {
    path: '/gd-dlysjg',
    name: 'gd-dlysjg',
    component: Main,
    meta: {
      // access: [],
      title: '两客一危一重',
      icon: 'ios-closed-captioning'
    },
    children: [
      {
        path: 'gddlysjghazardevents',
        name: 'gddlysjghazardevents',
        meta: {
          icon: 'ios-closed-captioning',
          title: '两客一危一重风险事件'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-hazard-events')
      },
      {
        path: 'gpsstandingbooks',
        name: 'gpsstandingbooks',
        meta: {
          icon: 'ios-closed-captioning',
          title: 'GPS台账'
        },
        component: () => import('@/view/gd-dlysjg/gps-standingbooks')
      },
      {
        path: 'gddlysjgvehiclequalifications',
        name: 'gddlysjgvehiclequalifications',
        meta: {
          icon: 'ios-closed-captioning',
          title: '业务资质'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-vehicle-qualifications')
      },
      {
        path: 'gddlysjglocatehistorys',
        name: 'gddlysjglocatehistorys',
        meta: {
          icon: 'ios-closed-captioning',
          title: '两客一危一重历史轨迹'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-locate-historys')
      },
      {
        path: 'gddlysjgvehicleanalyzereports',
        name: 'gddlysjgvehicleanalyzereports',
        meta: {
          icon: 'ios-closed-captioning',
          title: '两客一危一重车辆分析报告'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-vehicle-analyze-reports')
      },
      {
        path: 'gddlysjgvehicledatas',
        name: 'gddlysjgvehicledatas',
        meta: {
          icon: 'ios-closed-captioning',
          title: '两客一危一重业务资质'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-vehicle-datas')
      },
      {
        path: 'gddlysjgtruehazardevents',
        name: 'gddlysjgtruehazardevents',
        meta: {
          icon: 'ios-closed-captioning',
          title: '两客一危一重属实风险事件'
        },
        component: () => import('@/view/gd-dlysjg/gd-dlysjg-true-hazard-events')
      }
    ]
  },
  {
    path: '/im',
    name: 'im',
    component: Main,
    meta: {
      access: ['admin', 'dev1', 'operator', 'customerservice', 'accountant'],
      title: '库存管理',
      icon: 'md-cube'
    },
    children: [
      {
        path: 'siminfos',
        name: 'siminfos',
        meta: {
          icon: 'md-card',
          title: 'SIM卡信息管理'
        },
        component: () => import('@/view/im/sim-infos')
      },
      {
        path: 'positioningdeviceinfos',
        name: 'positioningdeviceinfos',
        meta: {
          icon: 'md-locate',
          title: '定位设备信息管理'
        },
        component: () => import('@/view/im/positioning-device-infos')
      },
      {
        path: 'positioningdevicetype',
        name: 'positioningdevicetype',
        meta: {
          icon: 'ios-settings',
          title: '定位设备类型管理'
        },
        component: () => import('@/view/im/positioning-device-type')
      },
      {
        path: 'positioningdevicefitting',
        name: 'positioningdevicefitting',
        meta: {
          icon: 'ios-settings',
          title: '配件信息管理'
        },
        component: () => import('@/view/im/positioning-device-fitting')
      },
      {
        path: 'positioningdevicefittingstype',
        name: 'positioningdevicefittingstype',
        meta: {
          icon: 'ios-settings',
          title: '配件类型管理'
        },
        component: () => import('@/view/im/positioning-device-fittings-type')
      }
    ]
  },
  {
    path: '/fm',
    name: 'fm',
    component: Main,
    meta: {
      access: ['admin'],
      title: '财务管理',
      icon: 'md-cash'
    },
    children: [
      {
        path: 'incomes',
        name: 'incomes',
        meta: {
          icon: 'logo-usd',
          title: '收入项管理'
        },
        component: () => import('@/view/fm/incomes')
      },
      {
        path: 'outlays',
        name: 'outlays',
        meta: {
          icon: 'md-cart',
          title: '支出项管理'
        },
        component: () => import('@/view/fm/outlays')
      }
    ]
  },
  {
    path: '/history',
    name: 'history',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
      title: '历史数据管理',
      icon: 'md-stopwatch'
    },
    children: [
      {
        path: 'locatehistorys',
        name: 'locatehistorys',
        meta: {
          access: ['admin', 'dev1', 'operator1', 'customerservice'],
          icon: 'md-stats',
          title: '历史定位数据管理'
        },
        component: () => import('@/view/history/locate-historys')
      },
      {
        path: 'locateplayback',
        name: 'locateplayback',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'operator1', 'customerservice'],
          icon: 'md-speedometer',
          title: '轨迹回放'
        },
        component: () => import('@/view/history/locate-playback')
      },
      {
        path: 'locateplaybackBD',
        name: 'locateplaybackBD',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'operator1', 'customerservice'],
          icon: 'md-speedometer',
          title: '轨迹回放-百度'
        },
        component: () => import('@/view/history/locate-playback-BD')
      }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'customerservice'],
      title: '分析设置',
      icon: 'ios-settings'
    },
    children: [
      {
        path: 'analysissetting',
        name: 'analysissetting',
        meta: {
          access: ['admin', 'operator', 'client'],
          icon: 'md-filing',
          title: '分析规则设置'
        },
        component: () => import('@/view/da/analysis-setting.vue')
      },
      {
        path: 'analysisscopesetting',
        name: 'analysisscopesetting',
        meta: {
          access: ['admin', 'operator', 'client'],
          icon: 'md-filing',
          title: '分析范围设置'
        },
        component: () => import('@/view/da/analysis-scope-setting.vue')
      }
    ]
  },
  {
    path: '/da',
    name: 'da',
    component: Main,
    meta: {
      access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
      title: '数据分析',
      icon: 'md-filing'
    },
    children: [
      {
        path: 'harddiskreports',
        name: 'harddiskreports',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: '硬盘分析报告'
        },
        component: () => import('@/view/da/hard-disk-reports')
      },
      {
        path: 'gnssreports',
        name: 'gnssreports',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: 'GNSS报告'
        },
        component: () => import('@/view/da/gnss-reports')
      },
      {
        path: 'alarmanalysiss',
        name: 'alarmanalysiss',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: '报警分析'
        },
        component: () => import('@/view/da/alarm-analysiss')
      },
      {
        path: 'asalarmanalysisresults',
        name: 'asalarmanalysisresults',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: '主动安全报警分析'
        },
        component: () => import('@/view/da/as-alarm-analysis-results')
      },
      // {
      //   path: 'offlineanalysiss',
      //   name: 'offlineanalysiss',
      //   meta: {
      //     access: ['admin', 'operator', 'marketsales', 'customerservice'],
      //     icon: 'md-document',
      //     title: '离线分析'
      //   },
      //   component: () => import('@/view/da/offline-analysiss')
      // },
      {
        path: 'vehicleofflineanalysisresults',
        name: 'vehicleofflineanalysisresults',
        meta: {
          access: ['admin'],
          icon: 'md-document',
          title: '车辆离线分析结果'
        },
        component: () => import('@/view/da/vehicle-offline-analysis-results')
      },
      {
        path: 'usergroupvehicleofflineanalysisresults',
        name: 'usergroupvehicleofflineanalysisresults',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: '团队车辆离线分析结果'
        },
        component: () => import('@/view/da/usergroup-vehicle-offline-analysis-results')
      },
      {
        path: 'unlocatedanalysiss',
        name: 'unlocatedanalysiss',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'customerservice', 'dev1'],
          icon: 'md-document',
          title: '不定位分析'
        },
        component: () => import('@/view/da/unlocated-analysiss')
      },
      {
        path: 'tripanalysiss',
        name: 'tripanalysiss',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
          icon: 'md-document',
          title: '行程分析'
        },
        component: () => import('@/view/da/trip-analysiss')
      },
      {
        path: 'attentionvehicleanalysiss',
        name: 'attentionvehicleanalysiss',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
          icon: 'md-document',
          title: '重点关注车辆分析'
        },
        component: () => import('@/view/da/attention-vehicle-analysiss')
      },
      {
        path: 'tracksintegrityanalysiss',
        name: 'tracksintegrityanalysiss',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
          icon: 'md-document',
          title: '轨迹完整分析'
        },
        component: () => import('@/view/da/tracks-integrity-analysiss')
      },
      {
        path: 'cndtriprecordanalysisresults',
        name: 'cndtriprecordanalysisresults',
        meta: {
          access: ['admin', 'operator', 'marketsales', 'dev1', 'customerservice'],
          icon: 'md-document',
          title: '两客一危车辆台账'
        },
        component: () => import('@/view/da/cnd-trip-record-analysis-results')
      },
      {
        path: 'wireless',
        name: 'wireless',
        meta: {
          access: ['admin', 'operator', 'dev1', 'client'],
          icon: 'md-filing',
          title: '信号强度'
        },
        component: () => import('@/view/signal/wireless.vue')
      },
      {
        path: 'drivercarddataanalysis',
        name: 'drivercarddataanalysis',
        meta: {
          access: ['admin', 'operator'],
          icon: 'md-filing',
          title: '司机卡信息'
        },
        component: () => import('@/view/da/driver-card-data-analysis.vue')
      },
      {
        path: 'drivercarddatagroupsanalysis',
        name: 'drivercarddatagroupsanalysis',
        meta: {
          access: ['admin', 'operator', 'marketsales'],
          icon: 'md-filing',
          title: '团队司机卡信息'
        },
        component: () => import('@/view/da/driver-card-data-groups-analysis.vue')
      },
      {
        path: 'mydrivercarddatagroupsanalysis',
        name: 'mydrivercarddatagroupsanalysis',
        meta: {
          access: ['admin', 'operator', 'marketsales'],
          icon: 'md-filing',
          title: '我的司机卡信息'
        },
        component: () => import('@/view/da/my-driver-card-data-analysis.vue')
      },
      {
        path: 'duplicateterminalnumanalysisresults',
        name: 'duplicateterminalnumanalysisresults',
        meta: {
          access: ['admin', 'operator', 'dev1', 'client'],
          icon: 'md-filing',
          title: '疑似串号分析结果'
        },
        component: () => import('@/view/da/duplicate-terminalnum-analysis-results.vue')
      },
      {
        path: 'stopsimcardanalysiss',
        name: 'stopsimcardanalysiss',
        meta: {
          access: ['admin', 'operator', 'client'],
          icon: 'md-filing',
          title: 'SIM卡停卡报表'
        },
        component: () => import('@/view/da/stop-sim-card-analysiss.vue')
      }
    ]
  },
  {
    path: '/acl',
    name: 'acl',
    component: Main,
    meta: {
      access: ['admin'],
      title: '用户权限管理',
      icon: 'ios-people'
    },
    children: [
      {
        path: 'users',
        name: 'users',
        meta: {
          icon: 'md-people',
          title: '用户管理'
        },
        component: () => import('@/view/acl/users')
      },
      {
        path: 'usergroups',
        name: 'usergroups',
        meta: {
          icon: 'md-people',
          title: '用户分组管理'
        },
        component: () => import('@/view/acl/user-groups')
      },
      {
        path: 'roles',
        name: 'roles',
        meta: {
          icon: 'md-ribbon',
          title: '角色管理'
        },
        component: () => import('@/view/acl/roles')
      }
    ]
  },
  {
    path: '/ops',
    name: 'ops',
    component: Main,
    meta: {
      access: ['admin', 'dev1'],
      title: '运维',
      icon: 'ios-cog'
    },
    children: [
      {
        path: 'systeminfo',
        name: 'systeminfo',
        meta: {
          access: ['admin', 'dev1'],
          icon: 'md-pie',
          title: '系统信息'
        },
        component: () => import('@/view/ops/system-info.vue')
      },
      {
        path: 'systemlogs',
        name: 'systemlogs',
        meta: {
          access: ['admin', 'dev1'],
          icon: 'md-document',
          title: '系统日志'
        },
        component: () => import('@/view/ops/system-logs.vue')
      },
      {
        path: 'backupdb',
        name: 'backupdb',
        meta: {
          icon: 'md-document',
          title: '数据库备份'
        },
        component: () => import('@/view/ops/backup-db.vue')
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          icon: 'md-notifications',
          title: '消息中心'
        },
        component: () => import('@/view/single-page/message/index.vue')
      }
    ]
  },
  {
    path: '/error_logger',
    name: 'error_logger',
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'error_logger_page',
        name: 'error_logger_page',
        meta: {
          icon: 'ios-bug',
          title: '错误收集'
        },
        component: () => import('@/view/single-page/webadmin-errorlog.vue')
      }
    ]
  },
  {
    path: '/argu',
    name: 'argu',
    meta: {
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'params/:id',
        name: 'params',
        meta: {
          icon: 'md-flower',
          title: route => `{{ params }}-${route.params.id}`,
          notCache: true,
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/argu-page/params.vue')
      },
      {
        path: 'query',
        name: 'query',
        meta: {
          icon: 'md-flower',
          title: route => `{{ query }}-${route.query.id}`,
          notCache: true
        },
        component: () => import('@/view/argu-page/query.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
